import React from 'react';

import { Comments } from '../Comments.component';

export const CommentsToefl = ({ ...props }) => {
  return (
    <Comments {...props}>
      <Comments.Mark />
      <Comments.EmptyAnswer />
      <Comments.TextArea />
    </Comments>
  );
};
